<template>

    <div class="TQ_center ongoingRiddle">



        <div class="TQ_center title TQ_fullScreen TQ_borderRadius_top"
             :style="co_dom_titleStyle_o">
            {{p_qb_riddle_c.qbr_title_blc_s[p_qb_displayLangCode_e]}}
        </div>

        <tq-on-top-container v-if="p_displayRiddleImage_b">

            <img slot="body"
                 class="TQ_fullScreen "
                 :src="p_qb_riddle_c.qbr_imgFile_blc_c[p_qb_displayLangCode_e].fi_url_s"/>

            <div slot="bottomRight" v-if="p_qb_metadata_c.qbm_missions_supportMissionsPoints_b" class="pointsLabel TQ_text_20px TQ_bold TQ_bg_purple_lite TQ_padding_4px">
                {{p_qb_riddle_c.cm_gbr_totalPoints_n()}} {{ass_strings.oneWord_points[p_qb_displayLangCode_e]}}
            </div>
        </tq-on-top-container>

         <!--0) riddle clock-->
        <div>
            <!-- ready clock -->
            <!--<div v-if="co_missionClock_ready_b">-->
            <!--    <tq-btn-approve-->
            <!--            class="TQ_inline TQ_margin_8px"-->
            <!--            :system-lang-code="p_qb_displayLangCode_e"-->
            <!--            :popup-text="ass_strings.sentence_showMission"-->
            <!--            :approve-cb="() => {}">-->
            <!--        <tq-beacon :p_show-beacon_b="true" class="TQ_clickable TQ_inline">-->
            <!--            <div class="TQ_padding_8px TQ_bg_purple TQ_margin_16px TQ_inline TQ_clickable TQ_box_shadow TQ_borderRadius TQ_text_24px ">-->
            <!--                {{ass_strings.twoWords_showMission[p_qb_displayLangCode_e]}}-->
            <!--            </div>-->
            <!--        </tq-beacon>-->
            <!--    </tq-btn-approve>-->
            <!--</div>-->

            <!-- running clock-->
            <!--<div v-if="co_missionClock_running_b" :style="co_dom_subTitle_o" class="TQ_padding_8px TQ_text_24px TQ_margin_8px_0">-->
            <!--    {{clockFormatTime_s}}-->
            <!--</div>-->

            <!-- finish clock -->
            <div v-if="co_missionClock_finish_b" :style="co_dom_subTitle_o" class="TQ_padding_8px TQ_text_24px TQ_margin_8px_0">
                {{co_totalFinishMissionTime_s}}
            </div>
        </div>

        <!-- 1) riddle body  -->
        <div v-html="p_qb_riddle_c.qbr_body_blc_c[p_qb_displayLangCode_e].w_body_s" class="TQ_padding_16px" ></div>

        <!-- 2) map section -->
        <div v-if="p_qb_riddle_c.qbr_metadata_c.qbrm_mapSection_b">

            <!-- use two fingers to move the map -->
            <tq-leaflet-display
                    :key="'cardsMap_' + p_name_s"
                    class="TQ_height_300px"

                    :pb_map-uid_s="p_name_s"

                    :p_map-data_c="p_qb_riddle_c.qbr_mapData_c"
                    :p_polygons_ac="p_qb_riddle_c.qbr_mapData_c.md_polygons_ac"

                    :pf_two-fingers-movement_b="true"/>

        </div>

        <!-- 3) riddle clues -->
        <div>


            <!-- used clues-->
            <div v-for="(qbr_clue_c, clueIndex) in p_qb_riddle_c.qbr_clues_ac"
                 v-if="m_showClue_fb(clueIndex)">
                <div class="TQ_center TQ_text_16px riddleSubTitle"
                     :style="co_dom_subTitle_o">
                    {{qbr_clue_c.qbrc_title_blc_s[p_qb_displayLangCode_e]}}
                </div>

                <div class="TQ_padding_4px">
                    <div v-html="qbr_clue_c.qbrc_body_blc_c[p_qb_displayLangCode_e].enc_value_s" ></div>
                </div>

                <div v-if=" [enum_cluesMode_e.points, enum_cluesMode_e.points_gradual].includes(p_qb_metadata_c.qbm_missions_cluesMode_e)"
                     class="TQ_text_bold TQ_padding_4px TQ_bg_red TQ_inline TQ_borderRadius TQ_margin_bottom_2px TQ_margin_top_4px TQ_direction_ltr">
                    <div class="TQ_text_bold TQ_inline TQ_verticalAlignTop"> -{{qbr_clue_c.qbrc_pointsWorth_n}}</div>
                    <div class="TQ_padding_2px TQ_inline TQ_verticalAlignTop"></div>
                    <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_width_16px TQ_inline TQ_verticalAlignTop"/>

                </div>
            </div>

            <!-- clue button -->
            <div class="TQ_btn TQ_bg_gold_w TQ_borderRadius TQ_margin_8px"
                 v-if="co_dom_showGetClue_b && !co_finishCurrentRiddle_b">

                <notification-container :num="p_cluesLeft_n ">
                    <img class="TQ_width_32px"
                         src="../../assets/svg/idea2_w.svg" />
                </notification-container>
                <div class="TQ_text_16px">
                    {{ass_strings.twoWords_revealHint[p_qb_displayLangCode_e]}}
                </div>
            </div>


        </div>

        <!-- 4) riddle locks -->
        <div v-for="(lock_c,lockIndex) in p_qb_riddle_c.qbr_locks_ac" :key="lockIndex">

            <!-- lock title-->
            <div class="TQ_center TQ_text_16px riddleSubTitle" :style="co_dom_subTitle_o">
                {{lock_c.qbrl_title_blc_s[p_qb_displayLangCode_e]}}
            </div>

            <!-- lock body -->
            <div>

                <!-- lock body -->
                <div v-if="lock_c.qbrl_body_blc_c[p_qb_displayLangCode_e].w_body_s !== ''"
                     v-html="lock_c.qbrl_body_blc_c[p_qb_displayLangCode_e].w_body_s"
                     class="TQ_border_bottom TQ_padding_16px"></div>

                <!-- skip -->
                <div v-if="m_dom_skipLock_fb(lockIndex)" class="TQ_margin_8px">
                    <img :src="ass_img_skip_w" class="TQ_bg_red TQ_width_32px TQ_padding_8px TQ_bg_circle"/>
                    <div>{{ass_strings.twoWords_SkippedRiddle[p_qb_displayLangCode_e]}}</div>
                </div>

                <!-- locks -->
                <div v-else>

                    <!-- QUIZ -->
                    <div v-if="[enum_lockTypes.QUIZ, enum_lockTypes.INCLUDE_WORD, enum_lockQuestionsTypes.WORDS, enum_lockQuestionsTypes.OPTIONS].includes(lock_c.qbrl_type_e)" >

                        <!-- Questions -->
                        <div v-for="(qbrl_questions_c, questionIndex_n) in lock_c.qbrl_questions_ac"
                            :key="questionIndex_n"
                             class="TQ_margin_bottom_8px TQ_padding_16px TQ_border_bottom">

                            <!-- body -->
                            <div v-html="qbrl_questions_c.qbrlq_body_blc_c[p_qb_displayLangCode_e].w_body_s"></div>

                            <!-- words -->
                            <div v-if="qbrl_questions_c.qbrlq_type_e === enum_lockQuestionsTypes.WORDS" >
                                <div v-for="ansIndex in qbrl_questions_c.qbrlq_ansNum_blc_n[p_qb_displayLangCode_e]" :key="ansIndex">


                                    <div v-if="m_dom_finishLock_fb(lockIndex)" class="TQ_margin_8px">
                                        <input disabled
                                               class="TQ_input"
                                               :value="m_getRiddleStatus_unlock_fc(lockIndex).rsud_quizUserAns_byQuestionIndex_as[questionIndex_n][ansIndex-1]"/>
                                    </div>

                                    <div v-else>
                                        <input-fast-delete

                                                class="TQ_margin_4px"
                                                delete-img-class="TQ_img TQ_img_19px"
                                                :input-placeholder="ass_strings.oneWord_answer[p_qb_displayLangCode_e]"
                                                input-class="TQ_input_fullScreen TQ_center TQ_text_16px"
                                                :update-text="(text) => {m_localUserAns_set_f(lockIndex, questionIndex_n, ansIndex-1,text)}"/>
                                        <div class="TQ_text_selectable">
                                            {{qbrl_questions_c.qbrlq_ans_blc_ac[p_qb_displayLangCode_e].map(encValue_c => encValue_c.enc_value_s)}}
                                        </div>
                                    </div>


                                </div>

                            </div>

                            <!-- Options -->
                            <div v-if="qbrl_questions_c.qbrlq_type_e === enum_lockQuestionsTypes.OPTIONS" >

                                <div v-for="ansIndex in qbrl_questions_c.qbrlq_ansNum_blc_n[p_qb_displayLangCode_e]" >
                                    <!-- unlock -->
                                    <div v-if="m_dom_finishLock_fb(lockIndex)" class="TQ_margin_8px">
                                        <input disabled
                                               class="TQ_input"
                                               :value="m_getRiddleStatus_unlock_fc(lockIndex).rsud_quizUserAns_byQuestionIndex_as[questionIndex_n][ansIndex-1]"/>
                                    </div>

                                    <!-- lock question-->
                                    <div v-else>
                                        <tq-dropdown class="TQ_input_fullScreen" :style-select="true" :ps_only-mobile-mode_b="true">

                                            <div slot="select" class="select">
                                            </div>

                                            <div    slot="options"
                                                    @click="m_localUserAns_set_f(lockIndex, questionIndex_n, ansIndex-1, option)"
                                                    class="option"
                                                    :class="{'TQ_optionSelected': m_localUserAns_get_f(lockIndex, questionIndex_n, ansIndex-1) === option}"
                                                    v-for="option in qbrl_questions_c.qbrlq_ansOptions_blc_ac[p_qb_displayLangCode_e]">
                                                {{option.enc_value_s}}
                                            </div>
                                        </tq-dropdown>
                                        <div>
                                            {{qbrl_questions_c.qbrlq_ans_blc_ac[p_qb_displayLangCode_e].map(encValue_c => encValue_c.enc_value_s)}}
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <!-- include word -->
                            <div v-if="qbrl_questions_c.qbrlq_type_e === enum_lockQuestionsTypes.INCLUDE_WORD" >

                                <!-- finish lock-->
                                <div v-if="m_dom_finishLock_fb(lockIndex)" class="TQ_margin_8px">

                                    <div>
                                        <input disabled
                                               class="TQ_input"
                                               :value="m_getRiddleStatus_unlock_fc(lockIndex).rsud_quizUserAns_byQuestionIndex_as[questionIndex_n][0]"/>

                                    </div>

                                </div>

                                <!-- unfinished lock-->
                                <div v-else>
                                    <input-fast-delete
                                            input-name="testName_lockWordsInput_arr"
                                            delete-img-class="TQ_img TQ_img_19px"
                                            :input-placeholder="ass_strings.oneWord_answer[p_qb_displayLangCode_e]"
                                            input-class="TQ_input_fullScreen TQ_center TQ_text_16px"
                                            :update-text="(text) => {m_localUserAns_set_f(lockIndex, questionIndex_n, 0, text)}"/>
                                    <div class="TQ_text_selectable">
                                        {{qbrl_questions_c.qbrlq_ans_blc_ac[p_qb_displayLangCode_e].map(encValue_c =>
                                        encValue_c.enc_value_s)}}
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- QRCode -->
                    <div v-if="lock_c.qbrl_type_e === enum_lockTypes.QR_CODE" class="TQ_margin_16px">

                        <!-- solve qr code-->
                        <div v-if="m_dom_finishLock_fb(lockIndex)">
                            <img :src="ass_img_lockQrCode" class="TQ_width_44px"/>
                            <div> {{ass_strings.threeWords_foundQRCode[p_qb_displayLangCode_e]}}</div>
                        </div>

                        <!-- search qr code-->
                        <div v-else
                             class="TQ_padding_8px">
                            <img :src="ass_img_camera" class="TQ_width_64px " />
                            <div class="TQ_text_bold">
                                {{ass_strings.threeWords_scanQRCode[p_qb_displayLangCode_e]}}
                            </div>
                        </div>


                    </div>

                    <!-- GPS LOCK -->
                    <div v-else-if="[enum_lockTypes.GPS].includes(lock_c.qbrl_type_e)" class="TQ_margin_8px">

                        <!-- answers table -->
                        <table v-if="p_riddleStatus_c && p_riddleStatus_c.rs_lockActions_byLockIndex_byTime_c[lockIndex]" class="TQ_inline TQ_text_14px">

                            <!-- header -->
                            <tr>
                                <td class="TQ_padding_4px TQ_border_bottom TQ_bg_gray4">
                                    {{ass_strings.oneWord_date[p_qb_displayLangCode_e]}}
                                </td>
                                <td class="TQ_padding_4px TQ_border_bottom TQ_bg_gray4">
                                    {{ass_strings.oneWord_player[p_qb_displayLangCode_e]}}
                                </td>
                                <td class="TQ_padding_4px TQ_border_bottom TQ_bg_gray4">
                                    {{ass_strings.oneWord_distance[p_qb_displayLangCode_e]}}
                                </td>
                                <td class="TQ_padding_4px TQ_border_bottom TQ_bg_gray4">
                                    {{ass_strings.oneWord_status[p_qb_displayLangCode_e]}}
                                </td>

                            </tr>

                            <!-- body-->
                            <tr v-for="rs_action_c in p_riddleStatus_c.rs_lockActions_byLockIndex_byTime_c[lockIndex]" :key="rs_action_c.rsla_timestamp_t">

                                <!-- date -->
                                <td v-if="m_getOtherUserData_c(rs_action_c.rsla_userId_uid)" class="TQ_padding_4px TQ_border_bottom">
                                    {{format_date_YYYY_MM_DD_hh_mm_fs(rs_action_c.rsla_timestamp_t)}}
                                </td>

                                <!-- user name -->
                                <td v-if="m_getOtherUserData_c(rs_action_c.rsla_userId_uid)" class="TQ_padding_4px TQ_border_bottom">
                                    {{m_getOtherUserData_c(rs_action_c.rsla_userId_uid).ud_name_s}}
                                </td>

                                <!-- distance -->
                                <td class="TQ_padding_4px TQ_border_bottom">
                                    {{m_calculateDistance_n(lock_c, rs_action_c)}}m
                                </td>

                                <!-- points -->
                                <td class="TQ_padding_4px TQ_border_bottom" >
                                    <tq-image :pb_src_r="rs_action_c.rsla_rightAns_b ? ass_img_checked : ass_img_closeRed" class="TQ_width_20px"/>
                                </td>

                            </tr>

                        </table>

                        <!-- finish lock-->
                        <div v-if="p_riddleStatus_c && p_riddleStatus_c.rs_m_finishActionLock_b(lockIndex)" class="TQ_padding_8px TQ_text_bold">


                            <!-- num of mistakes-->
                            <div class="TQ_margin_bottom_4px">
                                {{ass_strings.sentence_foundLocation[p_qb_displayLangCode_e]}}
                                ({{ Object.values(p_riddleStatus_c.rs_lockActions_byLockIndex_byTime_c[lockIndex]).length }}
                                {{ ass_strings.oneWord_tries[p_qb_displayLangCode_e] }})
                            </div>

                            <!-- points lock -->
                            <div class="TQ_inline TQ_bg_green TQ_padding_8px TQ_borderRadius TQ_direction_ltr" >
                                <div class="TQ_text_bold TQ_inline TQ_verticalAlignTop"> +{{p_riddleStatus_c.rs_m_actionLock_calcPoints_n(lockIndex)}}</div>
                                <div class="TQ_padding_2px TQ_inline TQ_verticalAlignTop"></div>
                                <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_width_16px TQ_inline TQ_verticalAlignTop"/>
                            </div>


                        </div>

                    </div>

                    <!-- image/video lock -->
                    <div v-else-if="[enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(lock_c.qbrl_type_e)" class="TQ_margin_16px">

                        <!-- btns -->
                        <div class="TQ_margin_bottom_8px" v-if="pe_updateLockStatus_f != null">

                            <!-- guide give score -->
                            <div v-if="lock_c.qbrl_guideGiveScore_b">
                                <div class="TQ_text_bold TQ_inline TQ_margin_4px">
                                    {{ass_strings.oneWord_points[p_qb_displayLangCode_e]}}
                                </div>
                                <input class="TQ_padding_4px TQ_center TQ_width_100px TQ_margin_4px"
                                       placeholder="0"
                                       v-model.number="m_getRiddleStatus_unlock_fc(lockIndex).rsud_receivedPoints_n">

                                <div class="TQ_padding_8px TQ_bg_green TQ_inline TQ_margin_8px TQ_borderRadius"
                                     @click="m_updateLockStatus_f(lockIndex, enum_lockStatus.approved)">
                                    update
                                </div>

                            </div>


                            <!-- regular approved not approved lock-->
                            <tq-loader-container v-else :p_show-loader_b="showLoader_lockStatusIndex_n === lockIndex" class="TQ_minHeight_48px">
                                <div class="TQ_btn TQ_bg_green TQ_margin_4px TQ_text_24px TQ_borderRadius"
                                     v-if="m_getRiddleStatus_unlock_fc(lockIndex).rsud_lockState_e !== enum_lockStatus.approved"
                                     @click="m_updateLockStatus_f(lockIndex, enum_lockStatus.approved)">
                                    {{ass_strings.oneWord_approve[p_qb_displayLangCode_e]}}
                                </div>

                                <div class="TQ_btn TQ_bg_red TQ_margin_4px TQ_text_24px TQ_borderRadius"
                                     v-if="m_getRiddleStatus_unlock_fc(lockIndex).rsud_lockState_e !== enum_lockStatus.notApproved"
                                     @click="m_updateLockStatus_f(lockIndex, enum_lockStatus.notApproved)">
                                    {{ass_strings.twoWords_notApproved[p_qb_displayLangCode_e]}}
                                </div>
                            </tq-loader-container>


                        </div>

                        <!-- uploaded image/video -->
                        <div>
                            <display-file
                                    v-if="m_dom_getLockDisplayImgFile_c(lockIndex, 0) != null"
                                    max-width="300px"
                                    :file="m_dom_getLockDisplayImgFile_c(lockIndex, 0)"/>
                            <!-- no image/video label-->
                            <div v-else-if="m_getRiddleStatus_unlock_fc(lockIndex).rsud_lockState_e !== enum_lockStatus.approved"
                                 class="TQ_inline TQ_maxWidth_200px TQ_border TQ_padding_32px TQ_bg_gray4 TQ_text_20px TQ_margin_bottom_8px">
                                <span v-if="[enum_lockTypes.IMAGE, enum_lockTypes.IMAGE_WITHOUT_APPROVED].includes(lock_c.qbrl_type_e)">{{ass_strings.fourWords_clickToUploadPhoto[p_qb_displayLangCode_e]}}</span>
                                <span v-else>{{ass_strings.fourWords_clickToUploadVideo[p_qb_displayLangCode_e]}}</span>
                            </div>
                        </div>

                        <!-- approve label-->
                        <div v-if="lock_c.qbrl_type_e !== enum_lockTypes.IMAGE_WITHOUT_APPROVED">
                            <div v-if="m_getRiddleStatus_unlock_fc(lockIndex).rsud_lockState_e === enum_lockStatus.approved"
                                 class="TQ_padding_8px TQ_text_bold TQ_text_20px TQ_bg_green">
                                {{ass_strings.oneWord_approved[p_qb_displayLangCode_e]}}
                            </div>
                            <div v-else-if="m_getRiddleStatus_unlock_fc(lockIndex).rsud_lockState_e === enum_lockStatus.notApproved"
                                 class="TQ_padding_8px TQ_text_bold TQ_text_20px TQ_bg_red">
                                {{ass_strings.twoWords_notApproved[p_qb_displayLangCode_e]}}

                            </div>
                            <div v-else-if="m_dom_getLockDisplayImgFile_c(lockIndex, 0) != null"
                                 class="TQ_padding_8px TQ_text_bold TQ_text_20px TQ_bg_gold_w">
                                {{ass_strings.threeWords_waitingToApprove[p_qb_displayLangCode_e]}}
                            </div>
                        </div>

                    </div>

                    <!-- finish lock icon-->
                    <div v-else-if="![enum_lockTypes.TRIVIA, enum_lockTypes.IMAGE, enum_lockTypes.VIDEO, enum_lockTypes.GPS].includes(lock_c.qbrl_type_e)" class="TQ_padding_8px">

                        <!-- points lock -->
                        <div v-if="p_qb_metadata_c.qbm_missions_supportMissionsPoints_b" class="TQ_inline TQ_bg_green TQ_padding_8px TQ_borderRadius TQ_direction_ltr" >
                            <div class="TQ_text_bold TQ_inline TQ_verticalAlignTop"> +{{lock_c.qbrl_points_n}}</div>
                            <div class="TQ_padding_2px TQ_inline TQ_verticalAlignTop"></div>
                            <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_width_16px TQ_inline TQ_verticalAlignTop"/>
                        </div>

                        <!-- regular lock -->
                        <div v-else class="TQ_inline TQ_bg_green TQ_padding_8px TQ_borderRadius">
                            <tq-image :pb_src_r="ass_img_unlock2_w" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                            <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_4px"></div>
                            <div class="TQ_text_bold TQ_inline TQ_verticalAlignMiddle">
                                {{ass_strings.twoWords_unlockLock[p_qb_displayLangCode_e]}}</div>
                        </div>

                    </div>

                </div>

            </div>
        </div>

        <!-- 5) last section -->
        <div v-if="false && p_qb_riddle_c.qbr_metadata_c.qbrm_finishSection_b && co_finishCurrentRiddle_b">

            <div class="TQ_btn TQ_bg_gold_w TQ_margin_8px"
                 @click="popup_lastSection_show_v.val = true">
                {{ass_strings.sentence_forMoreInfoClickHere[p_qb_displayLangCode_e]}}
            </div>

            <tq-popup :show="popup_lastSection_show_v"
                      margin="16px"
                      padding="8px"
                      :show-close-btn="true">

                <div v-html="p_qb_riddle_c.qbr_finishSection_blc_c[p_qb_displayLangCode_e].w_body_s"
                     class="TQ_margin_8px" >
                </div>

            </tq-popup>
        </div>



    </div>
</template>

<script>
    import {
        enum_lockState, enum_missions_LocksType_s,
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import TqCard from "../basic/TqCard";

    import NotificationContainer from "../basic/TqNotificationContainer";
    import Si_skip from "../a_smartIcons/si_skip";
    import Si_unlock from "../a_smartIcons/si_unlock";
    import Si_idea from "../a_smartIcons/si_clue";
    import Si_arrowRight from "../a_smartIcons/si_arrowsRight";
    import {helper_finishLock_fb, helper_finishRiddle_fb} from "../../scripts/S_Helper";
    import Si_arrowLeft from "../a_smartIcons/si_arrowsLeft";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqPopup from "../basic/TqPopup";
    import InputFastDelete from "../basic2/TqInputFastDelete";
    import DisplayFile from "../mediaComponenets/TqDisplayFile";
    import TqDropdown from "../basic/TqDropdown";
    import TqBtnApprove from "../basic2/TqBtnApprove";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import {
        ass_img_camera_b, ass_img_checked, ass_img_closeRed, ass_img_facebook_w,
        ass_img_image,
        ass_img_lock_w, ass_img_oneStar_w,
        ass_img_QrCode_b,
        ass_img_skip_w,
        ass_img_unlock2_w
    } from "../../assets/scripts/Ass_Files"
    import TqLeafletDisplay from "../maps/TqLeafletDisplay";
    import {
        format_date_YYYY_MM_DD_hh_mm_fs,
        format_duration_hhmmss,
        format_lockType_fs
    } from "../../../functions/src/shareCode/Share_S_Format";
    import {
        FB_File,
        FB_QuestBody_Metadata,
        FB_QuestBody_Riddle, FB_RiddleStatus
    } from "../../../functions/src/shareCode/Share_S_Classes";
    import {enum_langCodes, enum_lockQuestionsTypes, enum_lockTypes, enum_cluesMode_e} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqLoaderContainer from "../basic/TqLoaderContainer";
    import TqLoaderButton from "../basic2/TqLoaderButton";
    import TqImage from "../basic/TqImage";
    import TqBeacon from "@/components/basic2/TqBeacon";
    import {map_distanceTwoPointsMeters_fn} from "@/scripts/API/S_Map";
    import {serverAuth_getOtherUserData_f} from "@/scripts/Server/S_ServerAuth";

    export default {
        name: "TqRiddleData_warRoom",
        components: {
            TqBeacon,
            TqImage,
            TqLoaderButton,
            TqLoaderContainer,
            TqLeafletDisplay,
            TqOnTopContainer,
            TqDropdown,
            TqBtnApprove,
            DisplayFile,
            InputFastDelete,
            TqPopup,
            Si_arrowLeft,
            Si_arrowRight,
            Si_idea,
            Si_unlock,
            Si_skip,
            NotificationContainer,
            TqCard
        },
        props: {

            // ========= basic =============
            p_name_s                : {
                type: String,
                require: true,
            },
            p_qb_displayLangCode_e     : {
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },

            // ========= riddle data =============

            p_riddleStatus_c:{
                type: FB_RiddleStatus,
                require: true
            },
            p_qb_riddle_c:{
                type: FB_QuestBody_Riddle,
                require: true,
            },
            p_qb_metadata_c:{
                type: FB_QuestBody_Metadata,
                require: true
            },

            // ========= skips and clues =============
            p_cluesLeft_n :{
                type: Number,
                require: true
            },

            // ========= functions =============

            pe_updateLockStatus_f:{
                type: Function,
            },

            p_displayRiddleImage_b:{
                type: Boolean,
                default: false
            },

        },
        data(){
            return {

                userAns_byUserAnsId : {},
                userData_byUserId_c : {},

                showLoader_lockStatusIndex_n        : -1,
                popup_clue_selectedIndex_n          : 0,
                popup_lastSection_show_v            : {val: true},
                popup_qrCode_selectedLockIndex_n    : null,

                fileLock_clickedLockIndex_n         : null,

                // import assents
                format_lockType_fs              : format_lockType_fs,
                format_date_YYYY_MM_DD_hh_mm_fs : format_date_YYYY_MM_DD_hh_mm_fs,
                enum_cluesMode_e                : enum_cluesMode_e,
                enum_lockTypes                  : enum_lockTypes,
                enum_lockQuestionsTypes         : enum_lockQuestionsTypes,
                enum_lockStatus                 : enum_lockState,
                ass_strings                     : ass_strings,
                ass_img_unlock2_w               : ass_img_unlock2_w,
                ass_img_image                   : ass_img_image,
                ass_img_camera                  : ass_img_camera_b,
                ass_img_lockQrCode              : ass_img_QrCode_b,
                ass_img_skip_w                  : ass_img_skip_w,
                ass_img_lock_white              : ass_img_lock_w,
                ass_img_facebook                : ass_img_facebook_w,
                ass_img_oneStar_w               : ass_img_oneStar_w,
                ass_img_closeRed                : ass_img_closeRed,
                ass_img_checked                 : ass_img_checked,

            }
        },
        computed:{

            co_supportMissionClock_b(){
                return this.p_qb_metadata_c.qbm_missions_locksType_e === enum_missions_LocksType_s.start_time
            },
            co_missionClock_ready_b(){
                return this.co_supportMissionClock_b && (this.p_riddleStatus_c == null || this.p_riddleStatus_c.rs_startMissionTime_t === null)
            },
            co_missionClock_running_b(){
                return this.co_supportMissionClock_b && this.p_riddleStatus_c && this.p_riddleStatus_c.rs_startMissionTime_t !== null && !this.co_finishCurrentRiddle_b
            },
            co_missionClock_finish_b(){
                return this.co_supportMissionClock_b && this.p_riddleStatus_c && this.p_riddleStatus_c.rs_startMissionTime_t !== null && this.co_finishCurrentRiddle_b
            },
            co_totalFinishMissionTime_s(){
                if(this.co_missionClock_finish_b){
                    return format_duration_hhmmss(this.p_riddleStatus_c.rs_m_missionTotalTime_t())
                }
            },
            // dom
            co_dom_titleStyle_o(){
                return {
                    background  : this.p_qb_riddle_c.qbr_theme_c.qbrt_backgroundColor_s,
                    fontFamily  : this.p_qb_riddle_c.qbr_theme_c.qbrt_font_s,
                    color       : this.p_qb_riddle_c.qbr_theme_c.qbrt_textColor_s,
                    fontSize    : this.p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s}
            },
            co_dom_subTitle_o(){
                return {
                    background  : this.p_qb_riddle_c.qbr_theme_c.qbrt_backgroundColor_s,
                    fontFamily  : this.p_qb_riddle_c.qbr_theme_c.qbrt_font_s,
                    color       : this.p_qb_riddle_c.qbr_theme_c.qbrt_textColor_s,
                    fontSize    : 'calc(' + this.p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s + '-8px)'}
            },
            co_finishCurrentRiddle_b(){
                return helper_finishRiddle_fb(this.p_qb_riddle_c, this.p_riddleStatus_c)
            },
            co_dom_showGetClue_b(){
                return this.p_qb_riddle_c.qbr_clues_ac
                    && this.p_qb_riddle_c.qbr_clues_ac.length > 0
                    && this.co_getAvailableRiddleCluesIndex_a.length > 0
            },

            // other
            co_getAvailableRiddleCluesIndex_a(){
                let ans = [];
                for(let i = 0; i < this.p_qb_riddle_c.qbr_clues_ac.length; i++){
                    if(!this.m_showClue_fb(i))
                        ans.push(i)
                }
                return ans
            }
        },
        methods: {

            // local:
            m_showClue_fb(clueIndex){

                return this.p_riddleStatus_c != null &&
                    this.p_riddleStatus_c.rs_clues_byClueId_c != null &&
                    this.p_riddleStatus_c.rs_clues_byClueId_c[clueIndex] != null
            },
            m_getRiddleStatus_unlock_fc(lockId_n){

                if (this.p_riddleStatus_c == null
                    || this.p_riddleStatus_c.rs_unlock_byLockId_c == null
                    || this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n] == null)
                    return {};

                return this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n]
            },
            m_localUserAns_get_f(lockId_n, questionIndex, ansIndex){

                return this.userAns_byUserAnsId[this.m_helper_userAnsId_s(lockId_n, questionIndex, ansIndex)]
            },
            m_localUserAns_set_f(lockIndex, questionIndex, ansIndex, val){
                this.$set(this.userAns_byUserAnsId,  this.m_helper_userAnsId_s(lockIndex, questionIndex, ansIndex), val)
            },
            m_updateLockStatus_f(lockIndex_n, lockStatus_e){

                this.showLoader_lockStatusIndex_n = lockIndex_n

                this.pe_updateLockStatus_f(lockIndex_n, this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n], lockStatus_e, ()=>{
                    this.showLoader_lockStatusIndex_n = -1
                })
            },

            // dom
            m_dom_getLockDisplayImgFile_c(lockId_n, ansIndex_n){

                let localImage_b = this.m_localUserAns_get_f(lockId_n, null, ansIndex_n) != null
                let serverImage_b = this.p_riddleStatus_c != null
                    && this.p_riddleStatus_c.rs_unlock_byLockId_c != null
                    && this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n] != null
                    && this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n].rsud_imgFile_c != null

                let serverFile_fc = () => {return new FB_File(this.p_riddleStatus_c.rs_unlock_byLockId_c[lockId_n].rsud_imgFile_c)}
                let localFile_fc = () => {return this.m_localUserAns_get_f(lockId_n, null, ansIndex_n)}


                // get from server
                if(serverImage_b && localImage_b){
                    return localFile_fc()
                } else if(serverImage_b){
                    return serverFile_fc()
                } else if(localImage_b){
                    return localFile_fc()
                }else {
                    return null
                }

            },
            m_dom_finishLock_fb(lockIndex_n){

                if(this.p_riddleStatus_c == null || this.p_riddleStatus_c.rs_unlock_byLockId_c == null){
                    return false
                }
                


                return helper_finishLock_fb(this.p_riddleStatus_c, lockIndex_n, this.p_qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_type_e)
            },
            m_dom_skipLock_fb(lockIndex_n){

                if(this.p_riddleStatus_c == null
                    || this.p_riddleStatus_c.rs_unlock_byLockId_c == null
                    || this.p_riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n] == null){
                    return false
                }

                return this.p_riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n].rsud_skip_b
            },
            m_calculateDistance_n(qbr_lockData_c, rs_action_c){

                return map_distanceTwoPointsMeters_fn({
                    lat1: qbr_lockData_c.qbrl_gpsLocation_c.mp_lat_n,
                    lon1: qbr_lockData_c.qbrl_gpsLocation_c.mp_lng_n,
                    lat2: rs_action_c.rsla_geoLocation_c.ugl_latitude_n,
                    lon2: rs_action_c.rsla_geoLocation_c.ugl_longitude_n,
                })
            },
            m_getOtherUserData_c(userId_uid){

                if(this.userData_byUserId_c[userId_uid] !== undefined){
                    return this.userData_byUserId_c[userId_uid]
                }

                this.$set(this.userData_byUserId_c, userId_uid, null)

                serverAuth_getOtherUserData_f(userId_uid, (userData_c) => {
                    this.userData_byUserId_c[userId_uid] = userData_c
                })

                return this.userData_byUserId_c[userId_uid]
            },

            // helpers
            m_helper_userAnsId_s(lockIndex, questionIndex, ansIndex){
                return `${lockIndex}_${questionIndex}_${ansIndex}`
            },

        },
    }
</script>

<style scoped lang="scss">

    .title{
        padding: 8px 0px;
    }

    .pointsLabel{
        margin-bottom: 24px;
        border: 1px solid white;
        border-radius: 4px 0 0 8px;
    }


    .riddleSubTitle{
        background: gray;
        color: white;
        border-top:1px solid black;
        border-bottom:1px solid black;
        padding: 4px;
    }


    .clueSelectOption{
        padding: 8px 16px;
        display: grid;
        grid-template-columns: auto 1fr ;
    }

    .buttons{
        /*background: green;*/
        display: grid;
        grid-column-gap: 16px;

        &.twoGrid{
            grid-template-columns: auto auto ;
        }

        &.threeGrid{
            grid-template-columns: auto auto auto;
        }
    }




</style>